/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TermsAndConditionListRequest = {
    properties: {
        CompanyId: {
    type: 'number',
    isRequired: true,
},
    },
};